














import { Component, Vue, Prop } from 'vue-property-decorator';
import IFleet from '@/store/modules/fleet/types/IFleet';

@Component({})
export default class FleetItem extends Vue {
  @Prop({ type: Object, required: true }) private item!: IFleet;
}
